/** SimulatorStatus
 * generated by enums.tst
**/
var SimulatorStatus;
(function (SimulatorStatus) {
    SimulatorStatus[SimulatorStatus["Stopped"] = 0] = "Stopped";
    SimulatorStatus[SimulatorStatus["Starting"] = 1] = "Starting";
    SimulatorStatus[SimulatorStatus["Started"] = 2] = "Started";
    SimulatorStatus[SimulatorStatus["Stopping"] = 3] = "Stopping";
    SimulatorStatus[SimulatorStatus["Warning"] = 4] = "Warning";
    SimulatorStatus[SimulatorStatus["Error"] = 5] = "Error";
    SimulatorStatus[SimulatorStatus["UnexpectedExit"] = 6] = "UnexpectedExit";
    SimulatorStatus[SimulatorStatus["Testing"] = 7] = "Testing";
    SimulatorStatus[SimulatorStatus["Paused"] = 8] = "Paused";
})(SimulatorStatus || (SimulatorStatus = {}));
